import { styled } from '@mui/material/styles'

export const Banner = styled('div')`
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 1400;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 18px;
  border-radius: 999px;
  background: #272E35;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 18px;
  font-weight: 450;
  box-shadow: 0 6px 24px rgba(39, 46, 53, 0.28);
  pointer-events: none;
`

export const Dot = styled('span')`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #FFB020;
  flex-shrink: 0;
`

export const Muted = styled('span')`
  color: #A7B0BA;
`
